import { classNames } from "./classNames";

export type ButtonVariant = "primary" | "secondary" | "danger" | "dangerSolid" | "ghost";
export type ButtonSize = "xs" | "sm" | "md";

const VARIANT_CLASS: Record<ButtonVariant, string> = {
  primary: "app-button-primary",
  secondary: "app-button-secondary",
  danger: "app-button-danger",
  dangerSolid: "app-button-danger-solid",
  ghost: "app-button-ghost",
};

const SIZE_CLASS: Record<ButtonSize, string> = {
  xs: "app-button-xs",
  sm: "app-button-sm",
  md: "app-button-md",
};

/** A button's look, for `<button>` and for links that act as buttons alike. */
export function buttonClassName(variant: ButtonVariant, size: ButtonSize): string {
  return classNames(
    "app-button inline-flex items-center justify-center gap-1.5 focus:outline-none",
    VARIANT_CLASS[variant],
    SIZE_CLASS[size],
  );
}
